const EVENT_ACTIONS = {
  NEXT: "next",
  BACK: "back",
  INVEST: "invest",
  CONFIRM: "confirm",
  FUND_CLICKED: "fund_clicked",
  EDIT_RISK_PROFILE: "edit risk profile",
  EDIT_FUNDS: "edit funds",
  INFO_ICON: "info icon",
  CONTINUE: "continue",
  FUND_SELECTED: "fund selected",
  SAVE_CHANGES: "save changes",
  REPLACE_FUND: "replace fund",
  SELECT_DATE: "select a date",
  DONT_HAVE_CODE: "don’t have a code",
  CANCEL: "cancel",
  OKAY: "okay",
  ADD_CUSTOM_AMOUNT: "add a custom amount",
};

export default EVENT_ACTIONS;
